import { toast } from "vue3-toastify";

export const exportImage = async (
  canvas: HTMLCanvasElement,
  context: CanvasRenderingContext2D,
  area: string,
  img: string,
  file: File | undefined,
  fontSize: number,
  maxLines: number
) => {
  if (area != "") {
    canvas.width = 1025;
    canvas.height = 600;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = fontSize + "px Arial";
    const lineHeight = 35; // Set the line height for spacing
    const lines = area.split(/[\r\n]+/); // Split the text into an array of lines
    // Split lines further if they do not fit the canvas
    let i = 0;
    while (i < lines.length && i < maxLines) {
      const words = lines[i].split(" ");
      const lineArray = [];
      let line = "";
      for (let j = 0; j < words.length; j++) {
        const testLine = line + words[j] + " ";
        const testWidth = context.measureText(testLine).width;
        if (words[j] === "\n" || testWidth > canvas.width) {
          lineArray.push(line.trim());
          line = words[j] + " ";
        } else {
          line = testLine;
        }
      }
      lineArray.push(line.trim());
      lines.splice(i, 1, ...lineArray);
      i += lineArray.length;
    }

    const y = canvas.height / 2 - (lines.length * lineHeight) / 2;

    if (lines.length > maxLines) {
      toast.error(
        "Maximum number of lines exceed the limit, please try a smaller font!"
      );
      return [img, file, false];
    }

    for (let i = 0; i < lines.length; i++) {
      const textWidth = context.measureText(lines[i]).width;
      const x = (canvas.width - textWidth) / 2;
      context.fillText(lines[i], x, y + i * lineHeight);
    }
    img = canvas.toDataURL("image/png");

    const blob = await new Promise<BlobPart>((resolve) =>
      canvas.toBlob(resolve as BlobCallback)
    );
    const newFile = new File([blob], "image.png", { type: "image/png" });
    return [img, newFile, true];
  }
};
